import kebabCase from 'lodash/kebabCase';

import { SpateMetricMetadata } from 'utils/metrics';

export const FLAVORS_METADATA = {
    key: 'flavors',
    tableHeadColumnLabel: 'Flavors',
    notation: 'STRING',
    tooltipType: 'flavors',
    mixpanelContentKey: 'dataTableFlavors',
    tableColumnWidthMin: 8.4,
};

export const FLAVORS_METADATA_METRIC = new SpateMetricMetadata(
    FLAVORS_METADATA,
);

export const FLAVORS_SORT_OPTIONS = [
    {
        sortBy: 'flavors',
        label: 'Flavors',
        ascending: false,
        value: 'flavors high to low',
        mixpanelContentKey: 'dataTableFlavors',
        dataSource: 'TIKTOK',
    },
    {
        sortBy: 'flavors',
        label: 'Flavors',
        ascending: true,
        value: 'flavors low to high',
        mixpanelContentKey: 'dataTableFlavors',
        dataSource: 'TIKTOK',
    },
];

export const findCatThree = (catThreeOrAbove, groupedFlavorsOptions) =>
    catThreeOrAbove &&
    groupedFlavorsOptions &&
    groupedFlavorsOptions[catThreeOrAbove.catTwo]
        ? groupedFlavorsOptions[catThreeOrAbove.catTwo].find(
              (catThree) => catThree.catThree === catThreeOrAbove.catThree,
          )
        : null;

export const handleFlavorFilterChange = ({
    option,
    filters,
    setFilter,
    groupedFlavorsOptions,
    isChecked,
    isChip = false,
    onChange,
}) => {
    const { value, catTwo, catThree, depth } = option;

    if (isChip) {
        // Check if there's an existing cat4 filter under the same cat3 when modifying a cat3
        const foundCatFour = filters?.flavors?.find(
            (f) =>
                f.depth === 4 && f.catTwo === catTwo && f.catThree === catThree,
        );
        if (foundCatFour) {
            // Remove cat4 if cat3 is removed
            setFilter(
                'flavors',
                filters.flavors.filter((f) => f.value !== foundCatFour.value),
            );
        } else {
            // Standard removal of a filter
            onChange({ action: 'remove-value', option });
        }
        return;
    }

    if (depth === 4) {
        // Handle cat4 selection
        if (!isChecked) {
            // keeps the parent catThree checked
            const parentOfCurrentCheckedCatFour = findCatThree(
                filters.flavors.find((f) => f.depth === 4),
                groupedFlavorsOptions,
            );
            setFilter(
                'flavors',
                filters.flavors
                    .filter(
                        (f) => f.depth !== 4 && f.catThree !== option.catThree,
                    )
                    .concat([option])
                    .concat(
                        parentOfCurrentCheckedCatFour &&
                            parentOfCurrentCheckedCatFour.catThree !==
                                option.catThree
                            ? [parentOfCurrentCheckedCatFour]
                            : [],
                    ),
            );
        } else {
            // keeps the parent catThree checked
            const parentOfCurrentCheckedCatFour = findCatThree(
                option,
                groupedFlavorsOptions,
            );
            setFilter(
                'flavors',
                filters.flavors
                    .filter((f) => f.value !== option.value)
                    .concat(
                        parentOfCurrentCheckedCatFour
                            ? [parentOfCurrentCheckedCatFour]
                            : [],
                    ),
            );
        }
        return;
    }

    // Handling depth === 3
    // handle cat3 removed has cat4 filters selected
    const foundCatFour = filters?.flavors?.find(
        (f) => f.depth === 4 && f.catTwo === catTwo && f.catThree === catThree,
    );
    if (foundCatFour) {
        setFilter(
            'flavors',
            filters.flavors.filter((f) => f.value !== foundCatFour.value),
        );
        return;
    }
    // Handle "All cat2" selection behavior
    if (
        (filters?.flavors?.find(
            (f) => f.value === kebabCase(`all-${catTwo}`),
        ) &&
            !isChecked) ||
        value === kebabCase(`all-${catTwo}`)
    ) {
        if (value === kebabCase(`all-${catTwo}`) && isChecked) {
            setFilter(
                'flavors',
                filters?.flavors?.filter((f) => f.value !== value),
            );
        } else {
            // handle filter out all option when any cat3 applied
            setFilter(
                'flavors',
                (
                    filters?.flavors?.filter((f) => f.catTwo !== catTwo) || []
                ).concat([option]),
            );
        }
        return;
    }
    // handle deselect cat4 when any cat3 selected
    const anyCatFour = filters?.flavors?.find((f) => f.depth === 4);
    if (!isChecked && anyCatFour) {
        const parentOfCurrentCheckedCatFour = findCatThree(
            anyCatFour,
            groupedFlavorsOptions,
        );
        setFilter(
            'flavors',
            filters.flavors
                .filter((f) => f.depth !== 4)
                .concat([option, parentOfCurrentCheckedCatFour]),
        );
        return;
    }

    // Default select/deselect logic
    setFilter(
        'flavors',
        isChecked
            ? filters.flavors.filter((f) => f.value !== value)
            : (filters.flavors || []).concat([option]),
    );
};
